import { PreviewFrame } from "./PreviewFrame";
import { GhostMessageCard, MessageCard } from "./CommunicationPreview";
import { EMAIL_MESSAGE } from "./messages";

/**
 * Teaser for the locked Email channel in the inbox composer (Figma
 * BoomCRM-Paywall "Unlock email communication"): one received-email card on the
 * Pro gradient frame.
 */
export const EmailPreview = () => (
  <PreviewFrame height={329} noInnerCard badge="pro">
    <MessageCard
      message={EMAIL_MESSAGE}
      className="absolute"
      style={{
        left: "71px",
        top: "96px",
        width: "492px",
        filter:
          "drop-shadow(0 4px 2px rgba(0,0,0,0.25)) drop-shadow(0 4px 11px rgba(0,0,0,0.11))"
      }}
    />
  </PreviewFrame>
);

/**
 * The same teaser at the compact card's 399×190 (Figma 31:23290): a blurred
 * card behind, the received-email card in front, no timestamp or divider.
 */
export const EmailPreviewCompact = () => (
  <PreviewFrame compact badge="pro">
    <GhostMessageCard />
    <MessageCard
      size="sm"
      message={EMAIL_MESSAGE}
      className="absolute"
      style={{ left: "20px", top: "58px", width: "358px" }}
    />
  </PreviewFrame>
);
